export function getLineName(line) {
  return `${line.name} ${line.nick_name ? `- ${line.nick_name} ` : ''} ${line.unit_types_configuration_options?.is_mirrored ? '(mirrored)' : ''}`.trim() || `ID: ${line.id}`
}

export function getLineAsFloorName(line) {
  return line.name ? `Floor ${line.name}` : `Floor ${line.unit_type_levels[0]?.floor_number}`
}

export function getHumanLabelBathrooms(line) {
  const { number_of_bathrooms } = line
  if(!number_of_bathrooms){
    return null
  }
  return `${number_of_bathrooms} Bath${number_of_bathrooms > 1 ? 's' : ''}`
}

export function getHumanLabelBedrooms(line) {
  const { number_of_bedrooms } = line
  if (number_of_bedrooms === 0) {
    return 'Studio'
  }
  return `${number_of_bedrooms} Bed${number_of_bedrooms > 1 ? 's' : ''}`
}
